export enum PaginationValues {
    NEXT_PAGE = 'next',
    PREV_PAGE = 'prev',
    LAST_PAGE = 'last',
    FIRST_PAGE = 'first',
}
